import {defineStore} from "pinia";

const getLang = function () {

        if (navigator.userLanguage) {

            return navigator.userLanguage;

        } else if (navigator.language) {

            return navigator.language;

        }

        return "en-US";

    },

    getBrowserLanguage = function () {

        switch (getLang()) {

        case "en-US":
            return "en";
        case "en-AU":
            return "en";
        case "en-CA":
            return "en";
        case "en-IE":
            return "en";
        case "en-GB":
            return "en";
        case "en-JM":
            return "en";
        case "en-ZA":
            return "en";
        case "en-PH":
            return "en";
        case "ja":
            return "ja";
        case "ja-jp":
            return "ja";
        case "ja-JP":
            return "ja";
        case "ar":
            return "ar";
        case "ar-SA":
            return "ar";
        case "ar-AE":
            return "ar";
        case "ar-EG":
            return "ar";
        default:
            return "en";

        }

    },

    translationStore = defineStore(
        "translation",
        {
            "actions": {
                setLanguage(lang) {
                    this.VUE_APP_USER_LANGUAGE = lang;
                }
            },
            "getters": {
                "getLang": () => function () {

                    return getLang();

                },
                "localize": (state) => function (...args) {

                    const args_ = Array.prototype.slice.call(args),
                        i = args_[0],
                        r = [];
                    for (let j = 1; j < args_.length; j++) {

                        r.push(args_[j]);

                    }
                    if (!state.VUE_APP_USER_LANGUAGE) {

                        state.VUE_APP_USER_LANGUAGE = getBrowserLanguage();

                    }
                    if (!state[i]) {

                        return i;

                    }
                    if (state[i] && state.VUE_APP_USER_LANGUAGE) {

                        let localized = state[i][state.VUE_APP_USER_LANGUAGE];
                        if (!localized) {

                            return "";

                        }
                        if (r.length > 0) {

                            let l = 0;
                            for (const k in r) {

                                if (r[k]) {

                                    localized = localized.replace(
                                        `{${l}}`,
                                        r[k]
                                    );

                                } else {

                                    localized = localized.replace(
                                        `{${l}}`,
                                        ""
                                    );

                                }
                                l++;

                            }
                            return localized;

                        }
                        return localized;

                    }
                    return i;

                }
            },
            "state": () => ({
                "TEXT_HOME": {
                    "en": "Home",
                    "ja": "ホーム"
                },
                "TEXT_LOGIN": {
                    "en": "Login",
                    "ja": "ログイン"
                },
                "TEXT_LOGOUT": {
                    "en": "Logout",
                    "ja": "ログアウト"
                },
                "TEXT_CONNECT": {
                    "en": "Connect",
                    "ja": "接続"
                },
                "TEXT_MESSAGES": {
                    "en": "Messages",
                    "ja": "メッセージ"
                },
                "TEXT_CHATS": {
                    "en": "Chats",
                    "ja": "チャット"
                },
                "TEXT_SIGN_UP": {
                    "en": "Sign Up",
                    "ja": "サインアップ"
                },
                "TEXT_SENDING_FILE": {
                    "en": "Sending file...",
                    "ja": "ファイルを送信中..."
                },
                "LOGIN_CONNECT_WALLET": {
                    "en": "Connect your wallet to sign in.",
                    "ja": "ウォレットを接続してサインインしてください。"
                },
                "LOGIN_FAILED": {
                    "en": "Login failed. Please check your credentials.",
                    "ja": "ログインに失敗しました。資格情報を確認してください。"
                },
                "LOGIN_EMAIL_AVAILABLE": {
                    "en": "Email available",
                    "ja": "メールアドレスは利用可能です"
                },
                "LOGIN_ALREADY_REGISTERED_EMAIL": {
                    "en": "Email already registered",
                    "ja": "メールアドレスはすでに登録されています"
                },
                "CONTACT_WILL_CONTACT": {
                    "en": "Registration successful! Please check your email.",
                    "ja": "登録が成功しました！メールを確認してください。"
                },
                "CONTACT_ERROR": {
                    "en": "An error occurred. Please try again.",
                    "ja": "エラーが発生しました。もう一度お試しください。"
                },
                "TEXT_ABOUT": {
                    "en": "About",
                    "ja": "について"
                },
                "APP_SET_EMAIL": {
                    "en": "Set e-mail",
                    "ja": "メールアドレスを入力"
                },
                "TEXT_TERMS_CONDITIONS": {
                    "en": "Terms and Conditions",
                    "ja": "利用規約"
                },
                "LOGIN_INVALID_EMAIL": {
                    "en": "Please enter a valid email address",
                    "ja": "有効なメールアドレスを入力してください"
                },

                "AXON_NAV_SERVICES": {
                    "en": "Services",
                    "ar": "الخدمات",
                    "ja": "サービス"
                },
                "AXON_NAV_APPROACH": {
                    "en": "Approach",
                    "ar": "منهجنا",
                    "ja": "アプローチ"
                },
                "AXON_NAV_CONTACT": {
                    "en": "Contact",
                    "ar": "تواصل معنا",
                    "ja": "お問い合わせ"
                },

                "AXON_HERO_EYEBROW": {
                    "en": "Sovereign · Compliant · AI for Healthcare",
                    "ar": "ذكاء اصطناعي سيادي · متوافق · للرعاية الصحية",
                    "ja": "ソブリン · コンプライアント · 医療向けAI"
                },
                "AXON_HERO_TITLE_LINE_1": {
                    "en": "Sovereign, compliant AI",
                    "ar": "ذكاء اصطناعي سيادي ومتوافق",
                    "ja": "ソブリンで、コンプライアントなAI"
                },
                "AXON_HERO_TITLE_LINE_2": {
                    "en": "for healthcare.",
                    "ar": "للرعاية الصحية.",
                    "ja": "医療のために。"
                },
                "AXON_HERO_SUBTITLE": {
                    "en": "Our Makeen platform lets your teams use any AI tool — safely. It strips patient data from every request, enforces policy across the institution, and keeps you compliant, so your clinicians get intelligent answers while sensitive data never leaves the hospital.",
                    "ar": "تتيح منصّتنا مكين لفِرقك استخدام أي أداة ذكاء اصطناعي بأمان. تزيل بيانات المرضى من كل طلب، وتفرض السياسات على مستوى المؤسسة، وتحافظ على امتثالك — ليحصل الأطباء على إجابات ذكية دون أن تغادر البيانات الحساسة المستشفى.",
                    "ja": "私たちのMakeenプラットフォームは、あらゆるAIツールを安全に利用可能にします。すべてのリクエストから患者データを除去し、組織全体でポリシーを適用し、コンプライアンスを維持。臨床医はインテリジェントな回答を得ながら、機微なデータが病院の外に出ることはありません。"
                },
                "AXON_HERO_CTA_PRIMARY": {
                    "en": "Get in touch",
                    "ar": "تواصل معنا",
                    "ja": "お問い合わせ"
                },
                "AXON_HERO_CTA_SECONDARY": {
                    "en": "Explore Makeen",
                    "ar": "اكتشف مكين",
                    "ja": "Makeenを見る"
                },
                "AXON_HERO_HINT": {
                    "en": "Hover the lattice — each cube is a discipline. The axons are how they connect.",
                    "ar": "مرّر فوق الشبكة — كل مكعب يمثل تخصصاً، والمحاور تربط بينها.",
                    "ja": "格子にカーソルを合わせてください — 各キューブが領域、軸索（アクソン）がその接続です。"
                },

                "AXON_SERVICES_EYEBROW": {
                    "en": "What we do",
                    "ar": "ما نقدمه",
                    "ja": "提供サービス"
                },
                "AXON_SERVICES_TITLE": {
                    "en": "Seven disciplines, one connected practice.",
                    "ar": "سبعة تخصصات في ممارسة واحدة متصلة.",
                    "ja": "7つの領域、ひとつの統合された実践。"
                },
                "AXON_SERVICES_SUBTITLE": {
                    "en": "We bring together the capabilities a modern Saudi institution needs to deploy AI responsibly — under your control, on your terms.",
                    "ar": "نجمع القدرات التي تحتاجها مؤسسات المملكة الحديثة لنشر الذكاء الاصطناعي بمسؤولية — تحت سيطرتكم، وبشروطكم.",
                    "ja": "現代のサウジ機関が責任を持ってAIを導入するために必要な能力を、貴機関の管理下・条件のもとで統合します。"
                },

                "AXON_SVC_CONSULTING_TITLE": {
                    "en": "Strategic consulting",
                    "ar": "الاستشارات الاستراتيجية",
                    "ja": "戦略コンサルティング"
                },
                "AXON_SVC_CONSULTING_BODY": {
                    "en": "Vision 2030-aligned strategy, AI maturity assessments, and clear roadmaps from pilot to production.",
                    "ar": "فريق استشاري يفهم التحديات الصحية والتقنية، ويحوّلها إلى استراتيجيات متوافقة مع التوجهات الصحية للمملكة، يمكّنك من تقييم أفكارك وطموحاتك في الذكاء الاصطناعي، ويضع خرائط طريق واضحة تقود من التجارب الأولية إلى التطبيق الفعلي.",
                    "ja": "ビジョン2030に沿った戦略、AI成熟度評価、パイロットから本番まで明確なロードマップを提供。"
                },

                "AXON_SVC_SOVEREIGNTY_TITLE": {
                    "en": "Data & AI sovereignty",
                    "ar": "سيادة البيانات والذكاء الاصطناعي",
                    "ja": "データとAIの主権"
                },
                "AXON_SVC_SOVEREIGNTY_BODY": {
                    "en": "Architectures that keep sensitive data, models, and inference inside Saudi borders — aligned with SDAIA, NDMO and PDPL.",
                    "ar": "بنى تقنية تُبقي البيانات الحساسة والنماذج والاستدلال داخل حدود المملكة — متوافقة مع سدايا والمكتب الوطني لإدارة البيانات ونظام حماية البيانات الشخصية.",
                    "ja": "機密データ・モデル・推論をサウジ国内に留めるアーキテクチャ — SDAIA・NDMO・PDPLに準拠。"
                },

                "AXON_SVC_MODEL_TITLE": {
                    "en": "Model adaptation",
                    "ar": "تخصيص أنظمة الذكاء الاصطناعي",
                    "ja": "モデル適応"
                },
                "AXON_SVC_MODEL_BODY": {
                    "en": "Fine-tuning, distillation, and Arabic-first evaluation — turning frontier models into reliable clinical and operational tools.",
                    "ar": "ضبط دقيق وتقطير وتقييم متمحور حول اللغة العربية — لتحويل النماذج الرائدة إلى أدوات سريرية وتشغيلية موثوقة.",
                    "ja": "ファインチューニング・蒸留・アラビア語優先の評価により、フロンティアモデルを信頼できる臨床・業務ツールへ。"
                },

                "AXON_SVC_MAINTENANCE_TITLE": {
                    "en": "Operations & maintenance",
                    "ar": "صيانة وتشغيل الأنظمة الذكية",
                    "ja": "運用とメンテナンス"
                },
                "AXON_SVC_MAINTENANCE_BODY": {
                    "en": "24/7 monitoring, drift detection, model retraining, and SLAs that respect the rhythm of healthcare delivery.",
                    "ar": "نوفّر تشغيلاً وصيانة مرنين على مدار الساعة، مع مراقبة ذكية مستمرة، واكتشاف استباقي لأي تغيّر في الأداء، وإعادة ضبط وتحديث للنماذج عند الحاجة، ضمن التزام دقيق باتفاقيات مستوى الخدمة بما يتماشى مع طبيعة القطاع الصحي.",
                    "ja": "24/7監視、ドリフト検出、モデル再学習、医療提供のリズムを尊重するSLA。"
                },

                "AXON_SVC_CLOUD_TITLE": {
                    "en": "Cloud & infrastructure",
                    "ar": "الخدمات السحابية والبنية التحتية",
                    "ja": "クラウドとインフラ"
                },
                "AXON_SVC_CLOUD_BODY": {
                    "en": "Local cloud, hybrid GPU clusters, and private inference — built on Saudi-resident infrastructure partners.",
                    "ar": "خدمات سحابية خاصة، ومجموعات معالجة GPU هجينة، وتشغيل آمن للنماذج داخل بيئات معزولة، مدعومة ببنية تحتية مستضافة داخل المملكة عبر شركاء محليين موثوقين.",
                    "ja": "サブブリンクラウド、ハイブリッドGPUクラスタ、プライベート推論 — サウジ域内のインフラパートナー上に構築。"
                },

                "AXON_SVC_AGENTIC_TITLE": {
                    "en": "Agentic workflows",
                    "ar": "وكيل المهام الذكي",
                    "ja": "エージェンティック・ワークフロー"
                },
                "AXON_SVC_AGENTIC_BODY": {
                    "en": "Multi-agent systems that automate triage, documentation, and back-office work — with humans firmly in the loop.",
                    "ar": "أنظمة متعددة الوكلاء تُؤتمت الفرز والتوثيق وأعمال الدعم الإداري، مع إبقاء العنصر البشري جزءاً أساسياً من عملية القرار.",
                    "ja": "トリアージ・記録・バックオフィス業務を自動化するマルチエージェント・システム — 人間が中心に組み込まれます。"
                },

                "AXON_SVC_SOFTWARE_TITLE": {
                    "en": "Software development",
                    "ar": "تطوير البرمجيات",
                    "ja": "ソフトウェア開発"
                },
                "AXON_SVC_SOFTWARE_BODY": {
                    "en": "From clinical interfaces to internal platforms — engineered to integrate with what you already run, in Arabic and English.",
                    "ar": "من واجهات سريرية إلى منصات داخلية، مُصمَّمة لتتكامل بسلاسة مع أنظمتك الحالية، وتدعم اللغتين العربية والإنجليزية.",
                    "ja": "臨床インターフェースから社内プラットフォームまで、既存システムと統合できるようアラビア語と英語で開発。"
                },

                "AXON_SVC_CYBERSEC_TITLE": {
                    "en": "Cybersecurity",
                    "ar": "الأمن السيبراني",
                    "ja": "サイバーセキュリティ"
                },
                "AXON_SVC_CYBERSEC_BODY": {
                    "en": "An agentic cybersecurity platform — autonomous threat detection, response, and continuous compliance, powered by <a href=\"https://enbarr.ai\" target=\"_blank\" rel=\"noopener\" class=\"axon-inline-link\">Enbarr.ai</a>.",
                    "ar": "نقدّم منصة سيبرانية ذكية تعمل بشكل ذاتي لاكتشاف التهديدات والاستجابة لها، مع إدارة مستمرة للامتثال، مدعومة بالذكاء الاصطناعي لتعزيز حماية البنية الرقمية واتخاذ القرار في الوقت الحقيقي.",
                    "ja": "エージェント型サイバーセキュリティ・プラットフォーム — 自律的な脅威検出・応答と継続的なコンプライアンスを <a href=\"https://enbarr.ai\" target=\"_blank\" rel=\"noopener\" class=\"axon-inline-link\">Enbarr.ai</a> が支えます。"
                },
                "AXON_CARD_LEARN_MORE": {
                    "en": "Visit",
                    "ar": "زيارة الموقع",
                    "ja": "詳しく見る"
                },

                "AXON_CUBE_EYEBROW": {
                    "en": "Explore the system",
                    "ar": "انطلق معنا",
                    "ja": "システムを探索"
                },
                "AXON_CUBE_TITLE": {
                    "en": "How it all connects.",
                    "ar": "منظومة واحدة متكاملة.",
                    "ja": "すべてはひとつにつながる。"
                },
                "AXON_CUBE_SUBTITLE": {
                    "en": "Each face of our practice fits together. Drag to rotate the cube and find the discipline that fits your problem.",
                    "ar": "كل جانب في عملنا يتكامل بانسجام. حرّك المكعب لتكتشف الحل الذي صُمّم لاحتياجك.",
                    "ja": "私たちの実践の各面はひとつに組み合わさります。ドラッグして立方体を回転させ、課題に合う領域を見つけてください。"
                },
                "AXON_CUBE_HINT": {
                    "en": "Drag to rotate · Hover any cubie · Click a service cubie to jump to it.",
                    "ar": "اسحب لتدوير المكعب · مرّر فوق أي عنصر · انقر على أي خدمة للانتقال إليها مباشرة.",
                    "ja": "ドラッグで回転 · キューブにホバー · サービス・キューブをクリックで該当箇所へ。"
                },

                "AXON_MAKEEN_EYEBROW": {
                    "en": "Introducing Makeen",
                    "ar": "نقدّم لكم مكين",
                    "ja": "Makeen のご紹介"
                },
                "AXON_MAKEEN_TITLE": {
                    "en": "The AI Trust Platform",
                    "ar": "منصة الثقة في الذكاء الاصطناعي",
                    "ja": "AIトラスト・プラットフォーム"
                },
                "AXON_MAKEEN_LEAD": {
                    "en": "Makeen sits silently between your staff and every AI tool they use — inspecting each request, removing patient data before it reaches any model, and enforcing access policy across the whole institution. Your teams keep their tools. Your data stays home.",
                    "ar": "تعمل مكين بصمت بين موظفيك وكل أداة ذكاء اصطناعي يستخدمونها — تفحص كل طلب، وتزيل بيانات المرضى قبل وصولها إلى أي نموذج، وتفرض سياسة الوصول على مستوى المؤسسة بأكملها. تحتفظ فِرقك بأدواتها، وتبقى بياناتك في الداخل.",
                    "ja": "Makeenはスタッフと、彼らが使うあらゆるAIツールの間で静かに動作します。各リクエストを検査し、患者データがモデルに届く前に除去し、組織全体でアクセスポリシーを適用します。チームはツールをそのまま使い、データは院内に留まります。"
                },
                "AXON_MAKEEN_TAGLINE": {
                    "en": "Use any AI. Trust Makeen.",
                    "ar": "استخدم أي ذكاء اصطناعي. ثق بمكين.",
                    "ja": "どんなAIも、Makeenで安心。"
                },
                "AXON_MAKEEN_F1_TITLE": {
                    "en": "Auto-redaction",
                    "ar": "إخفاء تلقائي للبيانات",
                    "ja": "自動墨消し"
                },
                "AXON_MAKEEN_F1_BODY": {
                    "en": "Makeen is the AI interface your organisation routes every request through. We classify each request for PHI: where it can be redacted automatically we strip it and let the request proceed — where it can't, the request is denied.",
                    "ar": "مكين هي واجهة الذكاء الاصطناعي التي تمرّ عبرها كل طلبات مؤسستك. نصنّف كل طلب بحثاً عن البيانات الصحية: فحيث يمكن إخفاؤها تلقائياً نزيلها ونسمح للطلب بالمتابعة، وحيث يتعذّر ذلك يُرفض الطلب.",
                    "ja": "Makeenは、組織のすべてのリクエストが通るAIインターフェースです。各リクエストをPHIの有無で分類し、自動的に墨消しできる場合は除去して処理を続行、できない場合はリクエストを拒否します。"
                },
                "AXON_MAKEEN_F2_TITLE": {
                    "en": "Secure AI",
                    "ar": "ذكاء اصطناعي آمن",
                    "ja": "セキュアAI"
                },
                "AXON_MAKEEN_F2_BODY": {
                    "en": "Powered by our peer-reviewed KAIJU agent, the intent behind each request is understood and enforced within the agent — preventing harmful hallucination and prompt-injection attacks.",
                    "ar": "مدعومة بوكيل KAIJU المحكّم علمياً، تُفهَم نية كل طلب وتُفرَض داخل الوكيل — مما يمنع الهلوسة الضارة وهجمات حقن الأوامر.",
                    "ja": "査読済みのKAIJUエージェントを基盤に、各リクエストの意図をエージェント内で理解・強制し、有害なハルシネーションやプロンプトインジェクション攻撃を防ぎます。"
                },
                "AXON_MAKEEN_F3_TITLE": {
                    "en": "Compliance",
                    "ar": "الامتثال",
                    "ja": "コンプライアンス"
                },
                "AXON_MAKEEN_F3_BODY": {
                    "en": "Makeen enables compliance through audits, data security, and structured AI workflow logs. Interested in PDPL or HIPAA? Get in touch to learn more.",
                    "ar": "تتيح مكين الامتثال عبر التدقيق وأمن البيانات وسجلّات سير عمل الذكاء الاصطناعي المنظّمة. مهتم بـ PDPL أو HIPAA؟ تواصل معنا لمعرفة المزيد.",
                    "ja": "Makeenは、監査・データセキュリティ・構造化されたAIワークフローログによりコンプライアンスを実現します。PDPLやHIPAAにご関心がありますか？詳しくはお問い合わせください。"
                },
                "AXON_MAKEEN_F4_TITLE": {
                    "en": "Zero-touch for staff",
                    "ar": "دون أي تغيير على الموظفين",
                    "ja": "スタッフは設定不要"
                },
                "AXON_MAKEEN_F4_BODY": {
                    "en": "Deployed by IT via MDM across browser, desktop, and AI agents. No workflow change, no training — staff use ChatGPT, Claude, Nuance and more exactly as before, now protected.",
                    "ar": "تُنشر عبر إدارة الأجهزة (MDM) على المتصفح وسطح المكتب ووكلاء الذكاء الاصطناعي. لا تغيير في سير العمل ولا تدريب — يستخدم الموظفون ChatGPT وClaude وNuance كما كانوا، لكن بحماية الآن.",
                    "ja": "IT部門がMDM経由でブラウザ・デスクトップ・AIエージェントに展開。ワークフローの変更も研修も不要で、スタッフはChatGPTやClaude、Nuanceを従来どおり、しかし保護された状態で利用できます。"
                },
                "AXON_MAKEEN_STAT1_VALUE": {
                    "en": "< 200ms",
                    "ar": "< 200 مللي ثانية",
                    "ja": "< 200ms"
                },
                "AXON_MAKEEN_STAT1_LABEL": {
                    "en": "Decision latency, end to end",
                    "ar": "زمن اتخاذ القرار، من البداية للنهاية",
                    "ja": "エンドツーエンドの判定遅延"
                },
                "AXON_MAKEEN_STAT2_VALUE": {
                    "en": "> 95%",
                    "ar": "> 95%",
                    "ja": "> 95%"
                },
                "AXON_MAKEEN_STAT2_LABEL": {
                    "en": "PHI classification accuracy (AR & EN)",
                    "ar": "دقة تصنيف البيانات الصحية (عربي وإنجليزي)",
                    "ja": "PHI分類精度（アラビア語・英語）"
                },
                "AXON_MAKEEN_STAT3_VALUE": {
                    "en": "100%",
                    "ar": "100%",
                    "ja": "100%"
                },
                "AXON_MAKEEN_STAT3_LABEL": {
                    "en": "On-device redaction · data residency",
                    "ar": "إخفاء على الجهاز · إقامة البيانات محلياً",
                    "ja": "デバイス内墨消し・データ国内保持"
                },
                "AXON_MAKEEN_CTA": {
                    "en": "Get in touch",
                    "ar": "تواصل معنا",
                    "ja": "お問い合わせ"
                },

                "AXON_OFFER_EYEBROW": {
                    "en": "Our platform",
                    "ar": "منصتنا",
                    "ja": "私たちのプラットフォーム"
                },
                "AXON_OFFER_TITLE": {
                    "en": "Sovereign capabilities, end to end.",
                    "ar": "قدرات سيادية متكاملة من البداية إلى النهاية.",
                    "ja": "エンドツーエンドのソブリン機能。"
                },
                "AXON_OFFER_SUBTITLE": {
                    "en": "A connected suite of products that keep your data, security, and operations firmly under your control.",
                    "ar": "مجموعة متكاملة من المنتجات تُبقي بياناتك وأمنك وعملياتك تحت سيطرتك الكاملة.",
                    "ja": "データ・セキュリティ・業務を貴機関の管理下に保つ、連携した製品群。"
                },
                "AXON_OFFER_LEARN_MORE": {
                    "en": "Learn more →",
                    "ar": "اعرف المزيد ←",
                    "ja": "詳しく見る →"
                },
                "AXON_OFFER_1_TITLE": {
                    "en": "Data Protection",
                    "ar": "حماية البيانات",
                    "ja": "データ保護"
                },
                "AXON_OFFER_1_BODY": {
                    "en": "Data, models, and infrastructure stay on local soil — secured with AES-256-GCM encryption at rest, strict access controls, KYC, and full compliance.",
                    "ar": "تبقى البيانات والنماذج والبنية التحتية على الأرض المحلية — مؤمَّنة بتشفير AES-256-GCM أثناء التخزين، وضوابط وصول صارمة، وإجراءات اعرف عميلك، وامتثال كامل.",
                    "ja": "データ・モデル・インフラを国内に留め、保存時のAES-256-GCM暗号化、厳格なアクセス制御、KYC、完全なコンプライアンスで保護します。"
                },
                "AXON_OFFER_2_TITLE": {
                    "en": "Cybersecurity",
                    "ar": "الأمن السيبراني",
                    "ja": "サイバーセキュリティ"
                },
                "AXON_OFFER_2_BODY": {
                    "en": "An agentic cybersecurity platform delivering autonomous threat detection, response, and continuous compliance across your environment.",
                    "ar": "منصة أمن سيبراني وكيلة توفّر اكتشاف التهديدات والاستجابة لها بشكل ذاتي، مع امتثال مستمر عبر بيئتك بالكامل.",
                    "ja": "自律的な脅威検出・応答と継続的なコンプライアンスを環境全体で提供する、エージェント型サイバーセキュリティ・プラットフォーム。"
                },
                "AXON_OFFER_3_TITLE": {
                    "en": "Kaiju Agent for Enterprise",
                    "ar": "وكيل Kaiju للمؤسسات",
                    "ja": "Kaiju エンタープライズエージェント"
                },
                "AXON_OFFER_3_BODY": {
                    "en": "An enterprise AI agent that automates operational workflows and integrates with internal systems — always acting under human oversight.",
                    "ar": "وكيل ذكاء اصطناعي للمؤسسات يُؤتمت سير العمل التشغيلي ويتكامل مع الأنظمة الداخلية — مع بقائه دائماً تحت إشراف بشري.",
                    "ja": "業務ワークフローを自動化し、内部システムと統合するエンタープライズAIエージェント — 常に人間の監督下で動作します。"
                },
                "AXON_OFFER_4_TITLE": {
                    "en": "Clinical Intelligence",
                    "ar": "الذكاء السريري",
                    "ja": "クリニカル・インテリジェンス"
                },
                "AXON_OFFER_4_BODY": {
                    "en": "AI copilots that support clinicians with summarization, decision support, and documentation — kept private and on-premise.",
                    "ar": "مساعدو ذكاء اصطناعي يدعمون الأطباء بالتلخيص ودعم القرار والتوثيق — مع الحفاظ على الخصوصية والتشغيل داخل المؤسسة.",
                    "ja": "要約・意思決定支援・記録作成で臨床医を支援するAIコパイロット — プライベートかつオンプレミスで運用。"
                },

                "AXON_APPROACH_EYEBROW": {
                    "en": "How we work",
                    "ar": "أسلوب عملنا",
                    "ja": "私たちの方法"
                },
                "AXON_APPROACH_TITLE": {
                    "en": "Quiet engineering for high-stakes work.",
                    "ar": "أنظمة ذكية تُدار باحترافية وتُبنى بجودة عالية.",
                    "ja": "重要な領域のための、静かなエンジニアリング。"
                },
                "AXON_APPROACH_BODY": {
                    "en": "Healthcare and government don't need theatrics — they need systems that are explainable, observable, and demonstrably safe. We design with auditability from day one, deploy where data lives, and stay until the work is genuinely yours.",
                    "ar": "الرعاية الصحية لا تحتاج إلى استعراض، بل إلى أنظمة واضحة قابلة للتفسير، قابلة للمراقبة، وآمنة بشكل موثوق. نصمّم مع قابلية التدقيق منذ البداية، ونوظّفها حيث توجد البيانات، ونواصل العمل حتى تصبح المنظومة مستقلة بالكامل لديكم.",
                    "ja": "医療と政府には派手さは不要です。説明可能で、観測可能で、安全性が実証可能なシステムが必要です。私たちは初日から監査可能性を設計に組み込み、データのある場所で導入し、その仕事が真に貴機関のものになるまで伴走します。"
                },

                "AXON_CONTACT_EYEBROW": {
                    "en": "Let's talk",
                    "ar": "تحدث إلينا",
                    "ja": "お問い合わせ"
                },
                "AXON_CONTACT_TITLE": {
                    "en": "Partner with us to scope and deliver your sovereign AI initiative.",
                    "ar": "اعمل معنا لتحديد نطاق مبادرتك في الذكاء الاصطناعي السيادي وتنفيذها.",
                    "ja": "ソブリンAIの取り組みを、私たちと共に策定し実現しましょう。"
                },
                "AXON_CONTACT_CTA": {
                    "en": "Request a call",
                    "ar": "اطلب اتصالاً",
                    "ja": "通話を依頼する"
                },

                "AXON_CONTACT_FORM_TITLE": {
                    "en": "Send us a message",
                    "ar": "أرسل لنا رسالة",
                    "ja": "メッセージを送る"
                },
                "AXON_CONTACT_FORM_SUB": {
                    "en": "Tell us about your initiative and we'll get back to you shortly.",
                    "ar": "أخبرنا عن مبادرتك وسنعاود التواصل معك قريباً.",
                    "ja": "貴機関の取り組みについてお聞かせください。折り返しご連絡いたします。"
                },
                "AXON_CONTACT_FORM_NAME": {
                    "en": "Name",
                    "ar": "الاسم",
                    "ja": "お名前"
                },
                "AXON_CONTACT_FORM_NAME_PH": {
                    "en": "Your name",
                    "ar": "اسمك",
                    "ja": "お名前"
                },
                "AXON_CONTACT_FORM_EMAIL": {
                    "en": "Email",
                    "ar": "البريد الإلكتروني",
                    "ja": "メールアドレス"
                },
                "AXON_CONTACT_FORM_EMAIL_PH": {
                    "en": "you@organization.com",
                    "ar": "you@organization.com",
                    "ja": "you@organization.com"
                },
                "AXON_CONTACT_FORM_MESSAGE": {
                    "en": "Message",
                    "ar": "الرسالة",
                    "ja": "メッセージ"
                },
                "AXON_CONTACT_FORM_MESSAGE_PH": {
                    "en": "How can we help?",
                    "ar": "كيف يمكننا مساعدتك؟",
                    "ja": "どのようなご用件でしょうか？"
                },
                "AXON_CONTACT_FORM_SEND": {
                    "en": "Send message",
                    "ar": "إرسال الرسالة",
                    "ja": "送信する"
                },
                "AXON_CONTACT_FORM_SENDING": {
                    "en": "Sending…",
                    "ar": "جارٍ الإرسال…",
                    "ja": "送信中…"
                },
                "AXON_CONTACT_FORM_REQUIRED": {
                    "en": "Please fill in all fields.",
                    "ar": "يرجى تعبئة جميع الحقول.",
                    "ja": "すべての項目を入力してください。"
                },
                "AXON_CONTACT_FORM_BADEMAIL": {
                    "en": "Please enter a valid email address.",
                    "ar": "يرجى إدخال بريد إلكتروني صحيح.",
                    "ja": "有効なメールアドレスを入力してください。"
                },
                "AXON_CONTACT_FORM_FAILED": {
                    "en": "Something went wrong. Please try again.",
                    "ar": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
                    "ja": "エラーが発生しました。もう一度お試しください。"
                },
                "AXON_CONTACT_FORM_SUCCESS_TITLE": {
                    "en": "Message sent",
                    "ar": "تم إرسال الرسالة",
                    "ja": "送信しました"
                },
                "AXON_CONTACT_FORM_SUCCESS_SUB": {
                    "en": "Thank you for reaching out — we'll be in touch soon.",
                    "ar": "شكراً لتواصلك معنا — سنرد عليك قريباً.",
                    "ja": "お問い合わせありがとうございます。まもなくご連絡いたします。"
                },
                "AXON_CONTACT_FORM_DONE": {
                    "en": "Done",
                    "ar": "تم",
                    "ja": "閉じる"
                },
                "AXON_FOOTER_TAGLINE": {
                    "en": "Sovereign AI. Built in the Kingdom.",
                    "ar": "ذكاء اصطناعي سيادي. صُنع في المملكة.",
                    "ja": "主権AI。王国で構築。"
                }
            })
        }
    );

export {translationStore};
